import { Route, Routes } from "react-router-dom";
import { TopBar } from "./components/Shell";
import { I18nProvider } from "./i18n";
import RootPage from "./pages/RootPage";
import TripPage from "./pages/TripPage";

export default function App() {
  return (
    <I18nProvider>
      <div className="min-h-dvh bg-neutral-50 text-ink">
        <TopBar />
        <Routes>
          <Route path="/" element={<RootPage />} />
          <Route path="/:tripID" element={<TripPage />} />
        </Routes>
      </div>
    </I18nProvider>
  );
}
